import type { UPDATE_SUGGESTED_UNSUBSCRIBE_ALLOW_LISTActionMessage } from './actions/updateSuggestedUnsubscribeAllowList';
import type { MailboxInfo } from 'owa-client-types';
import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "SuggestedUnsubscribe"*/ './lazyIndex'),
    { name: 'SuggestedUnsubscribe' }
);

// Init/Fetching
export const lazyCreateSuggestedUnsubscribeItems: LazyAction<
    typeof lazyIndex.createSuggestedUnsubscribeItems,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.createSuggestedUnsubscribeItems);

// Lazy actions
export const lazyRemoveSuggestedUnsubscribeItem: LazyAction<
    (emailAddress: string, mailboxInfo: MailboxInfo) => void,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.removeSuggestedUnsubscribeItem);

export const lazyUpdateSuggestedUnsubscribeAllowList: LazyAction<
    (
        senderEmailAddress: string,
        mailboxInfo: MailboxInfo
    ) => UPDATE_SUGGESTED_UNSUBSCRIBE_ALLOW_LISTActionMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.updateSuggestedUnsubscribeAllowList);

// Types
export type { default as SuggestedUnsubscribeItem } from './store/schema/SuggestedUnsubscribeItem';

// Selectors
export { default as getSuggestedUnsubscribeItem } from './selectors/getSuggestedUnsubscribeItem';
export { default as isSuggestedUnsubscribeItem } from './selectors/isSuggestedUnsubscribeItem';

// Utils
export { default as getSuggestedUnsubscribeReasonString } from './utils/getSuggestedUnsubscribeReasonString';
